var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 411,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m186 1 53.5 107h-9l-68-107H186Z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m225 1 20 103.5h-6.5L205.38.97 225 1Z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m260 1-6 104.96h-8.5L242 1h18Z",
    fill: "url(#c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m297 1-33.5 104h-4L283 1h14Z",
    fill: "url(#d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m341 1-67.5 103.5h-10L317 1h24Z",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M404 1 288 106.5h-15L370.5 1H404Z",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m102.5 1 118 108.5H232L135 1h-32.5Z",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m500 88-217.5 45v-9L500 56.5V88Z",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 79.5 220.5 129l1-8.5L0 48v31.5Z",
    fill: "url(#i)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m500 155-219-12v-10l219-7v29Z",
    fill: "url(#j)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m0 144.5 218.5-9v-8L0 115.5v29Z",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m500 224-221.5-73v-8.5l221.5 49V224Z",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m0 213 216.54-69.75v-7.75L0 181v32Z",
    fill: "url(#m)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m500 308.5-222.5-147V151L500 269v39.5Z",
    fill: "url(#n)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m0 290.5 221.52-139.86v-9.14L0 254.5v36Z",
    fill: "url(#o)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M382 411 251.5 159.64H262L420 411h-38Z",
    fill: "url(#p)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m101 411 134-252.5h-12L63 411h38Z",
    fill: "url(#q)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m0 401 226-244.5-7.5-3L0 349.5V401Z",
    fill: "url(#r)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m297.63 411-51.87-256.63h5.5L334 411h-36.37Z",
    fill: "url(#s)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.5 411 241 155.37h-6.44L150.7 411h33.81Z",
    fill: "url(#t)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m225.5 411 16-254.5h7l9 254.5h-32Z",
    fill: "url(#u)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m489.5 411-224-245.5 3-11.5L500 371.5V411h-10.5Z",
    fill: "url(#v)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M500 13 297 117h-22L459.5 1H500v12Z",
    fill: "url(#w)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m0 3 223.5 119.5v-10L52.8 1H0v2Z",
    fill: "url(#x)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.05 193.9a.5.5 0 0 1 .9 0L37 206.17a.5.5 0 0 0 .37.28l13.53 1.96a.5.5 0 0 1 .27.85l-9.78 9.54a.5.5 0 0 0-.15.45l2.31 13.46a.5.5 0 0 1-.72.53l-12.1-6.36a.5.5 0 0 0-.46 0l-12.1 6.36a.5.5 0 0 1-.72-.53l2.3-13.46a.5.5 0 0 0-.14-.45l-9.78-9.54a.5.5 0 0 1 .27-.85l13.53-1.96a.5.5 0 0 0 .37-.28l6.05-12.25ZM100.1 274.82a1 1 0 0 1 1.8 0l4.74 9.62c.15.3.43.5.76.55l10.62 1.54a1 1 0 0 1 .55 1.7l-7.68 7.5a1 1 0 0 0-.3.88l1.82 10.57a1 1 0 0 1-1.45 1.06l-9.5-5a1 1 0 0 0-.92 0l-9.5 5a1 1 0 0 1-1.45-1.06l1.81-10.57a1 1 0 0 0-.29-.89l-7.68-7.49a1 1 0 0 1 .55-1.7l10.62-1.54a1 1 0 0 0 .75-.55l4.75-9.62Z",
    fill: "#1B6B55"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M100.55 273.9a.5.5 0 0 1 .9 0l5.31 10.77a.5.5 0 0 0 .38.28l11.88 1.72a.5.5 0 0 1 .28.86l-8.6 8.38a.5.5 0 0 0-.14.44l2.02 11.83a.5.5 0 0 1-.72.53l-10.63-5.59a.5.5 0 0 0-.46 0l-10.63 5.59a.5.5 0 0 1-.72-.53l2.02-11.83a.5.5 0 0 0-.14-.44l-8.6-8.38a.5.5 0 0 1 .28-.86l11.88-1.72a.5.5 0 0 0 .38-.28l5.31-10.76ZM154.05 321.9a.5.5 0 0 1 .9 0l1.64 3.33a.5.5 0 0 0 .37.27l3.67.54a.5.5 0 0 1 .28.85l-2.66 2.59a.5.5 0 0 0-.14.44l.63 3.65a.5.5 0 0 1-.73.53l-3.28-1.73a.5.5 0 0 0-.46 0l-3.28 1.73a.5.5 0 0 1-.73-.53l.63-3.65a.5.5 0 0 0-.14-.44l-2.66-2.59a.5.5 0 0 1 .28-.85l3.67-.54a.5.5 0 0 0 .37-.27l1.64-3.32ZM306.41 351.18a.1.1 0 0 1 .18 0l.62 1.26a.1.1 0 0 0 .08.06l1.39.2a.1.1 0 0 1 .05.17l-1 .98a.1.1 0 0 0-.03.09l.24 1.38a.1.1 0 0 1-.15.1l-1.24-.65a.1.1 0 0 0-.1 0l-1.24.66a.1.1 0 0 1-.14-.1l.23-1.4a.1.1 0 0 0-.03-.08l-1-.98a.1.1 0 0 1 .05-.17l1.4-.2a.1.1 0 0 0 .07-.06l.62-1.26ZM216.55 345.9a.5.5 0 0 1 .9 0l2.37 4.82a.5.5 0 0 0 .38.27l5.3.77a.5.5 0 0 1 .28.86l-3.84 3.74a.5.5 0 0 0-.14.44l.9 5.3a.5.5 0 0 1-.72.52l-4.75-2.5a.5.5 0 0 0-.46 0l-4.75 2.5a.5.5 0 0 1-.73-.53l.91-5.29a.5.5 0 0 0-.14-.44l-3.84-3.74a.5.5 0 0 1 .27-.86l5.31-.77a.5.5 0 0 0 .38-.27l2.37-4.81ZM417.55 315.9a.5.5 0 0 1 .9 0l2.37 4.82a.5.5 0 0 0 .38.27l5.3.77a.5.5 0 0 1 .29.86l-3.85 3.74a.5.5 0 0 0-.14.44l.9 5.3a.5.5 0 0 1-.72.52l-4.75-2.5a.5.5 0 0 0-.46 0l-4.75 2.5a.5.5 0 0 1-.73-.53l.91-5.29a.5.5 0 0 0-.14-.44l-3.85-3.74a.5.5 0 0 1 .28-.86l5.31-.77a.5.5 0 0 0 .38-.27l2.37-4.81ZM348.55 361.9a.5.5 0 0 1 .9 0l2.37 4.82a.5.5 0 0 0 .38.27l5.3.77a.5.5 0 0 1 .29.86l-3.85 3.74a.5.5 0 0 0-.14.44l.9 5.3a.5.5 0 0 1-.72.52l-4.75-2.5a.5.5 0 0 0-.46 0l-4.75 2.5a.5.5 0 0 1-.73-.53l.91-5.29a.5.5 0 0 0-.14-.44l-3.85-3.74a.5.5 0 0 1 .28-.86l5.31-.77a.5.5 0 0 0 .38-.27l2.37-4.81ZM493.05 276.9a.5.5 0 0 1 .9 0l3.1 6.31a.5.5 0 0 0 .38.27l2.15.34a.5.5 0 0 1 .42.5V297.63a.5.5 0 0 1-.75.44l-5.51-3.18a.5.5 0 0 0-.48-.01l-6.21 3.26a.5.5 0 0 1-.73-.53l1.2-6.92a.5.5 0 0 0-.15-.44l-5.03-4.9a.5.5 0 0 1 .27-.86l6.96-1a.5.5 0 0 0 .37-.28l3.11-6.3ZM51.55 90.9a.5.5 0 0 1 .9 0l3.84 7.8a.5.5 0 0 0 .38.27l8.6 1.25a.5.5 0 0 1 .27.85l-6.22 6.06a.5.5 0 0 0-.14.45l1.47 8.56a.5.5 0 0 1-.73.52l-7.69-4.04a.5.5 0 0 0-.46 0l-7.69 4.04a.5.5 0 0 1-.73-.52l1.47-8.56a.5.5 0 0 0-.14-.45l-6.22-6.06a.5.5 0 0 1 .28-.85l8.6-1.25a.5.5 0 0 0 .37-.27l3.84-7.8ZM116.5 1c.59 0 .7.84.12.99l-4.35 1.1a.5.5 0 0 0-.37.57l1.71 10a.5.5 0 0 1-.72.53l-9.16-4.82a.5.5 0 0 0-.46 0L94.1 14.2a.5.5 0 0 1-.72-.53l1.71-10a.5.5 0 0 0-.36-.58l-3.98-1.1c-.56-.15-.45-.98.13-.98h25.61ZM488.26 1c.15 0 .3.07.39.18l.93 1.14c.08.1.2.16.32.17l3.73.55a.5.5 0 0 1 .28.85l-2.66 2.58a.5.5 0 0 0-.14.45l.63 3.65a.5.5 0 0 1-.73.53l-3.28-1.73a.5.5 0 0 0-.46 0l-3.28 1.73a.5.5 0 0 1-.73-.53l.63-3.65a.5.5 0 0 0-.14-.45l-2.66-2.58a.5.5 0 0 1 .28-.85l3.7-.54a.5.5 0 0 0 .35-.22l.73-1.06a.5.5 0 0 1 .41-.22h1.7ZM420.05 23.9a.5.5 0 0 1 .9 0l3.1 6.3a.5.5 0 0 0 .38.28l6.96 1.01a.5.5 0 0 1 .27.85l-5.03 4.9a.5.5 0 0 0-.14.45l1.19 6.92a.5.5 0 0 1-.73.53l-6.22-3.27a.5.5 0 0 0-.46 0l-6.22 3.27a.5.5 0 0 1-.73-.53l1.2-6.92a.5.5 0 0 0-.15-.44l-5.03-4.9a.5.5 0 0 1 .27-.86l6.96-1a.5.5 0 0 0 .37-.28l3.11-6.3Z",
    fill: "#1B6B55"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 275.5 -273.599 0 250 135.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1B6B55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1B6B55",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1B6B55",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B6B55",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupBonus);
export default __webpack_public_path__ + "static/media/popup-bonus.8073d09eac9357d4672a41be3187febb.svg";
export { ForwardRef as ReactComponent };